import { Card, CardSection, CardRow, CardRowState,CardFileState,CardFile, CardTask,CardTaskAction } from "tessa/cards";
import { IControlViewModel, ICardUIExtensionContext ,ICardModel} from "tessa/ui/cards";
import { DotNetType, TypedField,  Guid, createTypedField} from "tessa/platform";
import { CheckBoxViewModel, GridRowAction, GridViewModel  } from "tessa/ui/cards/controls";
import { showMessage, showError, showNotEmpty, showLoadingOverlay} from "tessa/ui";
import { CdCardTypes } from "../CdCardTypes";
import { ValidationResult, ValidationResultBuilder, ValidationResultType } from "tessa/platform/validation";
import { MetadataStorage } from 'tessa';
import { UIContext, UIButton, createCardModel } from "tessa/ui";
import { CardNewRequest, CardService, CardRequest, CardGetFileContentRequest } from "tessa/cards/service";
import { ChFileCategories } from "src/pkScripts/Helpers/ChFileCategories";
import { showFormDialog } from 'tessa/ui/uiHost';
import { CdRequestTypes } from "../CdRequestTypes";
import { ArrayStorage, IStorageArray } from "tessa/platform/storage";
import { CdEDSHelper, CustomCertData } from "../CdEDSHelper";
import { CdFdProcessHelper } from "../CdFdProcessHelper";
import { CdExtensionHelper } from "../CdExtensionHelper";
import { CdRequestForMaterialsSharedHelper } from "./CdRequestForMaterialsSharedHelper";
import { ApproversRoleID } from "../Dictionaries/ApproversRoleID";
import { CdUIHelper } from "src/cdScripts/UI/CdUIHelper";
import { CdExecutiveSchemeSharedHelper } from "./CdExecutiveSchemeSharedHelper";
import { IFile } from "tessa/files";
import { CdDocStates } from "../CdDocStates";
import { CdDSSHelper } from "../CdDSSHelper";
import { userSession } from "common/utility";
import { CdFileTypes } from "../CdFileTypes";
import { CdExecutiveSchemeTypes } from "../CdExecutiveSchemeTypes";
import { ChTaskTypes } from "src/pkScripts/Helpers/ChTaskTypes";


export class CdGeneralDocumentationClientHelper {
  
  public static PdfForPrint: string = ' (для печати).pdf';

//#region Подписание

  /** Проверки РД */
  public static async TechnicalDocumentationCheckFileAsync(card: Card, file: IFile, certificate: CustomCertData | null) {
    let validationResult = new ValidationResultBuilder();
    let unsignedHash: string | null = null;
    
    if (!card.typeId || card.typeId !== CdCardTypes.TechnicalDocumentationTypeID) {
      return {Result: validationResult, UnsignedHash: unsignedHash};
    }

    // проверка Qr кода
    await showLoadingOverlay(async () => {
      let stampAdded = await this.CheckQrCode(file.lastVersion.id);
      if (!stampAdded) {
        validationResult.add(ValidationResultType.Error, "QR-код еще не проставлен.");
        return {Result: validationResult, UnsignedHash: unsignedHash};
      }
    }, "Проверка наличия QR-кода.");

    if (validationResult.items.length > 0) {
      return {Result: validationResult, UnsignedHash: unsignedHash};
    }

    // проставление штампа и добавление его в карточку
    try {
      await showLoadingOverlay(async () => {
        // получение файла со штампом
        let fileWithStamp = await this.GetRdWithWorkStampAsync(
          card.id,
          file.lastVersion.id,
          file.id,
          file.name,
          certificate?.ownerOrganization ?? null,
          certificate?.ownerName ?? null,
          certificate?.companyAdr ?? null);

        // обновление файла в карточке
        const fileData = new File([fileWithStamp.Blob], file.name);
        await file.replace(fileData, false);
        
        // хеш файла со штампом
        unsignedHash = fileWithStamp.UnsignedHash;
      }, "Проставление штампа \"Выдано в производство работ\".");
    } catch (ex) {
      validationResult.add(
          ValidationResultType.Error,
          'Возникли ошибки при проставлении штампа \"Выдано в производство работ\".\n' +
          "Пожалуйста, обратитесь к администратору, приложив детальное сообщение об ошибке.\n" +
          "Детальное сообщение можно скопировать, нажав кнопку \"Копировать\", " +
          "либо открыв его кликом по ошибке и скопировав стандартным способом.",
          undefined,
          undefined,
          undefined,
          ValidationResult.fromError(ex).items.map(x => x.message + "\n" + x.details)[0]);
      return {Result: validationResult, UnsignedHash: unsignedHash};
    }

    return {Result: validationResult, UnsignedHash: unsignedHash};
  }

  /** Подписние файлов */
  public static async SignFilesAsync(context: ICardUIExtensionContext, tasks: ArrayStorage<CardTask>,  taskTypes:guid[]) {
    let card = context.card;
    let unsignedFiles: {ID: string, Hash?: string | null}[] = [];

    // проверка наличия завершенного задания на подписани
    if (tasks == null) return;
    let task = tasks.find(t => (taskTypes.findIndex(x =>
      x.toLocaleLowerCase() === t.typeId.toLocaleLowerCase()) >= 0) &&
      t.action === CardTaskAction.Complete &&
      t.optionId === CdFdProcessHelper.Sign);
    if (task == null) return;

    let fileCategory  =
    Guid.equals(card.typeId, CdCardTypes.TechnicalDocumentationTypeID)
    ? ChFileCategories.Approval
    : Guid.equals(card.typeId, CdCardTypes.PkExecutiveSchemeTypeID)
    ? ChFileCategories.ImplementingSchemes
    : Guid.equals(card.typeId, CdCardTypes.PkExecutiveDocumentationTypeID) ? ChFileCategories.DocumentID 
    : ChFileCategories.RequestForMaterials;

    let categoryID = fileCategory.id;

    // список файлов на подписание
    let files: IFile[] = context.fileContainer.files
      .filter(x =>
        x.category &&
        x.category.id == categoryID &&
        !x.name.includes(this.PdfForPrint));
    if (files.length == 0) {
      
      showError('Нет файла в категории '+ fileCategory.caption +'.');
      context.cancel = true;
      return;
    }

    // для РД сразу выбираем сертификат для заполнения штампа
    let isRD = card.typeId == CdCardTypes.TechnicalDocumentationTypeID;
    let certificate: CustomCertData | null = null;
    if (isRD) {
      let selectedCert = await CdEDSHelper.GetCertificatePlatformAsync(context.model.edsProvider);
      if (!selectedCert.Certificate) {
        context.cancel = true;
        throw new Error('Не выбран сертификат.');
      }
      certificate = selectedCert.Certificate;
    }
    for (let file of files) {
      let technicalDocumentationResult = await CdGeneralDocumentationClientHelper.TechnicalDocumentationCheckFileAsync(
        card,
        file,
        certificate);
      if (technicalDocumentationResult.Result.items && technicalDocumentationResult.Result.items.length > 0) {
        showNotEmpty(technicalDocumentationResult.Result.build());
        context.cancel = true;
        return;
      }

      unsignedFiles.push({ID: file.id, Hash: technicalDocumentationResult.UnsignedHash});
    }

    // прикрепленная подпись
    let isAttachedSignature = await this.CheckIsAttachedSignatureAsync(card, context.fileContainer.files);

    // DSS подписание (с выходом из метода при успешном подписании)
    if (!isAttachedSignature) {
      let isDSS = await this.SignFilesByDSSAsync(
        context,
        userSession.UserID,
        categoryID,
        unsignedFiles.map(x => x.ID)
      );

      if (isDSS) {
        return;
      }
    }
    
    // CAdES подписание
    let edsResult = await CdEDSHelper.SignFilesAsync(
      context.fileContainer,
      context.model.edsProvider,
      card,
      unsignedFiles,
      !isAttachedSignature
    );

    if (!edsResult.isSuccessful) {
      context.cancel = true;
      showNotEmpty(edsResult.build());
      return;
    }

    // Заполнение специальных полей
    await this.ExecutiveDocumentationAdditionalSignFileLogicAsync(card);
    await this.ExecutiveSchemeAdditionalSignFileLogicAsync(card, task.typeId);
    await this.RequestForMaterialsAdditionalSignFileLogicAsync(card, task.rowId);
  }

  /** Проверить необходимость подписания прикрепленной подписью. */
  public static async CheckIsAttachedSignatureAsync(card: Card, files: readonly IFile[]): Promise<boolean> {
    let isAttachedSignature: boolean =
      (card.typeId == CdCardTypes.PkExecutiveDocumentationTypeID &&
      card.sections.has('PkExecutiveDocumentationInfo') &&
      card.sections.get('PkExecutiveDocumentationInfo')?.fields.has('isExternalBuilder') &&
      card.sections.get('PkExecutiveDocumentationInfo')?.fields.get('isExternalBuilder') == true &&
      files.find(x => x.lastVersion.signatures.length > 0) == undefined) ||

      (card.typeId == CdCardTypes.PkExecutiveSchemeTypeID &&
        card.sections.has('PkExecutiveDocumentationInfo') &&
        card.sections.get('PkExecutiveDocumentationInfo')?.fields.has('SigningTypeID') &&
        card.sections.get('PkExecutiveDocumentationInfo')?.fields.get('SigningTypeID') == 1 &&
        card.sections.has('PkExecutiveSchemeInfo') &&
        card.sections.get('PkExecutiveSchemeInfo')?.fields.has('IsRenovation') &&
        card.sections.get('PkExecutiveSchemeInfo')?.fields.get('IsRenovation') == true &&
        card.sections.get('PkExecutiveSchemeInfo')?.fields.has('ExecutiveSchemeTypeID') &&
        card.sections.get('PkExecutiveSchemeInfo')?.fields.get('ExecutiveSchemeTypeID') == CdExecutiveSchemeTypes.GeodeticSchemeType)

      ? true : false;

    return isAttachedSignature
  }

  /** Подписание файлов через DSS. */
  public static async SignFilesByDSSAsync(
    context: ICardUIExtensionContext,
    userID: string,
    categoryID: string | null,
    files: string[]): Promise<boolean> {
    let card: Card = context.card;

    // получаем данные для подписания
    const signingInfo = await CdDSSHelper.GetSigningInfoAsync(card, userID, false, true, true); 
    
    // если есть данные по DSS
    if (signingInfo.employeeGuid1C != null && signingInfo.dssCspType != null) {
      for (let file of card.files.filter(x => files.includes(x.rowId))) {
        // подписываем файлы через DSS
        await CdDSSHelper.SignFilesByDssAsync(
          context,
          userID,
          signingInfo.externalUserGuid,
          signingInfo.employeeGuid1C,
          signingInfo.dssCspType,
          signingInfo.certInfo,
          file.name,
          categoryID);
      }
      
      return true;
    } else {
      return false;
    }
  }

  /** Добавить роль для печатной формы в ИД. */
  private static async ExecutiveDocumentationAdditionalSignFileLogicAsync(card: Card) {
    if (card.typeId != CdCardTypes.PkExecutiveDocumentationTypeID) {
      return;
    }
    
    let pdciSection = card.sections.tryGet('PkDocumentCommonInfo');
    if (pdciSection) {
      let stateID: number | null | undefined = pdciSection.fields.tryGet('StateID');
        switch (stateID) {
          case CdDocStates.OnApprovalSubcontractor.id:
          case CdDocStates.OnSigningSubcontractor.id:
            card.info['SignRoleID'] = 0;
            break;

          case CdDocStates.OnApprovalContractor.id:
          case CdDocStates.OnSigningContractor.id:
            card.info['SignRoleID'] = 1;
            break;

          case CdDocStates.OnApprovalGPExecutorWorks.id:
          case CdDocStates.OnSigningGPExecutorWorks.id:
            card.info['SignRoleID'] = 2;
            break;

          case CdDocStates.OnApprovalGP.id:
          case CdDocStates.OnSigningGP.id:
            card.info['SignRoleID'] = 3;
            break;

          case CdDocStates.OnApprovalAuthorSupervision.id:
          case CdDocStates.OnSigningAuthorSupervision.id:
            card.info['SignRoleID'] = 4;
            break;

          case CdDocStates.OnApprovalCustomer.id:
          case CdDocStates.OnSigningCustomer.id:
            card.info['SignRoleID'] = 5;
            break;

          case CdDocStates.OnApprovalOperatingOrganization.id:
          case CdDocStates.OnSigningOperatingOrganization.id:
            card.info['SignRoleID'] = 6;
            break;

          case CdDocStates.OnApprovalASEngeneer.id:
            card.info['SignRoleID'] = 8;
            break;

          default:
            card.info['SignRoleID'] = -1;
      }
    }
  }
  
  /** Добавить роль для печатной формы в ИС. */
  private static async ExecutiveSchemeAdditionalSignFileLogicAsync(card: Card, taskTypeID: string) {
    if (card.typeId != CdCardTypes.PkExecutiveSchemeTypeID) {
      return;
    }

    if (taskTypeID == ChTaskTypes.PkSignerAgreementTypeID) {
      card.info['WithRole'] = true;
    }
  }
  
  /** Добавить роль для печатной формы в заявках на материалы. */
  private static async RequestForMaterialsAdditionalSignFileLogicAsync(card: Card, taskID: string) {
    if (card.typeId != CdCardTypes.PkRequestForMaterialsTypeID) {
      return;
    }

    card.info['WithRole'] = true;
    card.info['RoleTaskID'] = createTypedField(taskID, DotNetType.Guid);;
  }

  /** Проверка на наличие Qr кода у файла. */
  private static async CheckQrCode(versionRowID: string) {
    const request = new CardRequest();
    request.requestType = CdRequestTypes.CdCheckQrCodeFile;
    request.info["FileVersionID"] = createTypedField(versionRowID, DotNetType.Guid);

    const response = await CardService.instance.request(request);
    await showNotEmpty(response.validationResult.build());
    if (!response.validationResult.isSuccessful) {
        return false;
    }

    if (!response.info!.Result ||
        !response.info!.Result.$value) {
        return false;
    }

    return true;
  }

  /** Сформировать штамп для РД */
  public static async GetRdWithWorkStampAsync(
    cardID: string,
    versionRowID: string,
    fileID: string,
    fileName: string,
    certCompany: string | null,
    certOwner: string | null,
    certAdr: string | null) {
    let unsignedHash: string | null = null;

    const cardGetFileContentRequest = new CardGetFileContentRequest();
    cardGetFileContentRequest.fileTypeName = CdFileTypes.GetInWorkStampType;
    cardGetFileContentRequest.cardId = cardID;
    cardGetFileContentRequest.versionRowId = versionRowID;
    cardGetFileContentRequest.fileId = fileID;
    cardGetFileContentRequest.fileName = fileName;
    cardGetFileContentRequest.info["CertCompany"] = createTypedField(certCompany, DotNetType.String);
    cardGetFileContentRequest.info["CertOwner"] = createTypedField(certOwner, DotNetType.String);
    cardGetFileContentRequest.info["CertAdr"] = createTypedField(certAdr, DotNetType.String);
    cardGetFileContentRequest.info["Date"] = createTypedField(new Date(), DotNetType.DateTime);
    cardGetFileContentRequest.info["WithHash"] = createTypedField(true, DotNetType.Boolean);

    const cardGetFileContentResponse = await CardService.instance.getFileContent(cardGetFileContentRequest);

    if (!cardGetFileContentResponse.validationResult.isSuccessful) {
      throw new Error('Ошибка при получении файла со штампом (' + versionRowID + '): ' + cardGetFileContentResponse.validationResult.build().toString());
    }

    if (cardGetFileContentResponse.content == null ||
      cardGetFileContentResponse.size === 0) {
      throw new Error('Ошибка при получении файла со штампом (' + versionRowID + '): Вернулся пустой файл.');
    }

    // TODO TIV: В вебе не работает Response.Info
    //unsignedHash = cardGetFileContentResponse.info.UnsignedHash;

    return {Blob: cardGetFileContentResponse.content, UnsignedHash:unsignedHash};
  }

//#endregion

  public static async FillTableApprovers(card: Card, roles: ApprovementRoles[] | null | undefined, matchingSectionName: string, matchingRolesSectionName: string)
  {
    let mSection = card.sections.tryGet(matchingSectionName);
    let rSection = card.sections.tryGet(matchingRolesSectionName);
    if (!mSection)
    {
        return;
    }
    if (mSection.rows.length != 0)
    {
      for (let i = mSection.rows.length - 1; i >= 0; i--) {     
        if (mSection.rows[i].state === CardRowState.Inserted)
          mSection.rows.splice(i, 1);
        else mSection.rows[i].state = CardRowState.Deleted;
      }     
    }    
    //очищаем полностью роли
    if (rSection) {
      for (let j = rSection.rows.length - 1; j >= 0; j--) {
        let row = rSection.rows[j];
        if (row.state !== CardRowState.Inserted) {
            row.state = CardRowState.Deleted;
        } 
        else
        {
          rSection.rows.remove(row);
        }
      }
    }

    if (roles == null) return;
    if (roles.length > 0){
      roles.forEach(role => {
        const esmSectionRow = new CardRow();    
        esmSectionRow.rowId = Guid.newGuid();        
        esmSectionRow.set("RoleID", role.RoleID, DotNetType.Guid);
        esmSectionRow.set("RoleName", role.RoleName, DotNetType.String);
        esmSectionRow.set("SpecialRoleID", role.SpecialRoleID, DotNetType.Guid);
        esmSectionRow.set("SpecialRoleName", role.SpecialRoleName, DotNetType.String);
        esmSectionRow.set("LegalEntityID",null, DotNetType.Guid);
        esmSectionRow.set("LegalEntityExternalID", null, DotNetType.Int32);
        esmSectionRow.set("LegalEntityName", null, DotNetType.String);
        esmSectionRow.set("Order", role.DefaultOrder, DotNetType.Int32);
        esmSectionRow.state = CardRowState.Inserted;
        mSection!.rows.push(esmSectionRow);
      });
    }     
  }  

  public static FieldsObjectsLogic(card: Card, model: ICardModel) {
    let ediSection = card.sections.tryGet('PkExecutiveDocumentationInfo');    

    // Заполнение ЖК для при смене объекта
    const objects = model.controls.get('Objects') as GridViewModel;
    if (objects && ediSection && ediSection.fields.has('ResidentialComplexID')) {
      objects.rowInitializing.add(e => {
        e.row.fieldChanged.add(e1 => {
          if (e1.fieldName === 'ResidentialComplexID') {
            let residentialComplexID = e1.fieldValue as guid | undefined;
            if (residentialComplexID && ediSection) {
              ediSection.fields.set('ResidentialComplexID', createTypedField(residentialComplexID, DotNetType.Guid));
            }
          } else if (e1.fieldName === 'RegionID') {
            let regionID = e1.fieldValue as guid | undefined;
            if (regionID && ediSection) {
              ediSection.fields.set('RegionID', createTypedField(regionID, DotNetType.Guid));
            }
          }
        });
      });
    }
  }

  public static async GetRoles(card: Card, ...additionalFilters: ((roles: ApprovementRoles[])=>void)[])
  {
    let roles: ApprovementRoles[] = [];      
    
    try
    {
      const request = new CardRequest();
      request.requestType = CdRequestTypes.GetApprovementRoles;
      request.info["CardTypeID"] = createTypedField(card.typeId, DotNetType.Guid);
  
      const response = await CardService.instance.request(request);
      await showNotEmpty(response.validationResult.build());
      if (!response.validationResult.isSuccessful) {
          return null;
      }
      let result: [{RoleID: any, RoleName: any, SpecialRoleID: any, SpecialRoleName: any, DefaultOrder: any, ApprovementRolesCriteria: IStorageArray[], ApprovementRolesActiveCriteria: IStorageArray[]}] = response.info.Roles;
      if (result.length>0)
      {
        for (let index = 0; index < result.length; index++) {
          let role = result[index];
          roles.push( {
            RoleID: role.RoleID!.$value
            , RoleName: role.RoleName!.$value
            , SpecialRoleID: role.SpecialRoleID!=null?role.SpecialRoleID.$value:null
            , SpecialRoleName: role.SpecialRoleName!=null?role.SpecialRoleName.$value:null 
            , DefaultOrder: role.DefaultOrder!.$value
            , ApprovementRolesCriteria: role.ApprovementRolesCriteria==null?null:role.ApprovementRolesCriteria.map(x=> { 
                let a: ApprovementRolesCriteria = 
                {
                  RowID: x["RowID"]!.$value,
                  SectionName: x["SectionName"]!.$value,
                  FdCriteriaOperatorID : null,
                  FieldName : x["FieldName"]!.$value,
                  Value: x["Value"]!.$value,
                };                    
                return a;
              })
              , ApprovementRolesActiveCriteria: role.ApprovementRolesActiveCriteria==null?null:role.ApprovementRolesActiveCriteria.map(x=> { 
                let a: ApprovementRolesCriteria = 
                {
                  RowID: x["RowID"]!.$value,
                  SectionName: x["SectionName"]!.$value,
                  FieldName : x["FieldName"]!.$value,
                  FdCriteriaOperatorID : x["FdCriteriaOperatorID"]!.$value,
                  Value: x["Value"]!.$value,
                };                    
                return a;
              })
          });
        }
      }
      
      this.FilterRolesByActiveCriteria(card, roles);
    }
    catch (err)
    {
      showError(err);
    }     
    additionalFilters.forEach(filter=>filter(roles))
    return roles;
  } 

  private static async FilterRolesByActiveCriteria(card: Card, roles: ApprovementRoles[])
  {
    for (let i = roles.length - 1; i >= 0; i--)
    {
      if (roles[i].ApprovementRolesActiveCriteria == null || roles[i].ApprovementRolesActiveCriteria?.length == 0)
      {
          continue;
      }

      // проверка в зависимости от оператора    
      roles[i]!.ApprovementRolesActiveCriteria!.forEach(item => {
        let operatorId = item.FdCriteriaOperatorID;
        switch (operatorId)
        {
            case (FdCriteriaOperators.NonEquals as number):
            case (FdCriteriaOperators.Equals as number):
                {
                  let section = card.sections.tryGet(item.SectionName);
                    if (!section|| !section.fields.has(item.FieldName))
                    {
                        return;
                    }

                    var value = section!.fields.get(item.FieldName)!.toString().toLowerCase();
                    if (value != item.Value!.toLowerCase() && operatorId == (FdCriteriaOperators.Equals as number))
                    {
                        roles.splice(i, 1);
                    }
                    else if (value == item.Value!.toLowerCase() && operatorId == (FdCriteriaOperators.NonEquals as number))
                    {
                        roles.splice(i, 1);
                    }

                    break;
                }

            default:
                {
                    break;
                }
        }
      });
    }    
  }

  private static async GetApprovers(card: Card, roles: ApprovementRoles[] | null)
  {
    let roleIds = roles!.map(x => x.RoleID);
    let roleApprovers: RoleApprovers<guid>[] = [];
    let direction : guid|null = null;
    let investProjectInfoSection: CardSection | undefined = card.sections.tryGet('PkInvestProjectInfo');    
    if (investProjectInfoSection)
      direction = investProjectInfoSection.fields.tryGet("DirectionID");
    
    try
    {
      const request = new CardRequest();
      let rolesList = roleIds.map(x=>createTypedField(x, DotNetType.Guid));
      request.requestType = CdRequestTypes.GetApprovementParticipants;
      request.cardId = card.id;
      request.info["DirectionID"] = direction==null?null:createTypedField(direction, DotNetType.Guid);
      request.info["Roles"] = rolesList

      // находим все необходимые поля из критериев ролей согласования
      let approvementRolesCriteria : ApprovementRolesCriteria[] = [];
      if (roles)
      {
        let rolesCriteria = roles!.filter(r => r.ApprovementRolesCriteria && r.ApprovementRolesCriteria.length>0)!.map(x => x.ApprovementRolesCriteria)!.filter(x=>x!.length>0);
        let totalApprovementRolesCriteria = (rolesCriteria!=null && rolesCriteria.length>0)?rolesCriteria!.reduce(self=>self):[];
        
        for (let i = 0; i < totalApprovementRolesCriteria!.length; i++) {
          let cur_criteria = totalApprovementRolesCriteria![i];
          if (approvementRolesCriteria.some(x => x!.SectionName == cur_criteria.SectionName && x.FieldName == cur_criteria.FieldName))
            continue;

          else 
          {            
            approvementRolesCriteria.push(cur_criteria);
          }
        }
      }

      // добавляем все в запрос
      for (let i = 0; i < approvementRolesCriteria!.length; i++)
      {
        let item = approvementRolesCriteria[i];        
        var key = item.SectionName+"_"+item.FieldName;
       
        let section = card.sections.tryGet(item.SectionName);
        if (section)
        {          
          if (section.fields.has(item.FieldName))
          {
            request.info[key] = section.fields.get(item.FieldName)!+"";
          }
        }
      }
     
      const response = await CardService.instance.request(request);
      await showNotEmpty(response.validationResult.build());
      if (!response.validationResult.isSuccessful) {
          return null;
      }
      
      let participants = response.info.Participants;
      if (!participants || participants!.length == 0) return;
      if (!roleIds) return;
      roleIds.forEach(role => {
        let roleParticipants = participants.filter(x=>x.RoleID!.$value==role);

        if (!roleParticipants || roleParticipants!.length==0) return;        
        let approversList:{ID:guid,Name:string}[] = []
        for (let k = 0; k < roleParticipants.length; k++) {          
          approversList.push({ID:roleParticipants[k]["ParticipantID"]!.$value,Name:roleParticipants[k]["ParticipantName"]!.$value});       
        }
        roleApprovers.push( {
          RoleID: role
          , OrderNumber: createTypedField(null, DotNetType.String)
          , OrderDate: createTypedField(null, DotNetType.DateTime)
          , Approvers: approversList
        } );
      });
      if (await this.GetApproversByRdDivisionRoles(card,roleIds,roleApprovers)!=true) return;
      if (await this.GetApproversLegalEntityInfo(roleApprovers)!=true) return;
    }
    catch (err)
    {
      showError(err);
    }    
    return roleApprovers;
  } 


  public static async GetApproversLegalEntityInfo<T>(roleApprovers:RoleApprovers<T>[])
  {
    if (!roleApprovers|| roleApprovers.length==0) return true;
    const request = new CardRequest();
    request.requestType = CdRequestTypes.GetLegalEntity;   

    request.info["Approvers"] = roleApprovers
    .map(x=> x.Approvers)
    .reduce((x,y)=>x.concat(y),[])
    .map(x=>x.ID)
    .filter((val, i, arr) => arr.findIndex(x => x === val) === i)
    .map(x=>`('${x}')`)
    .join(',');

    if (request.info["Approvers"]==='') return true;
   
    const response = await CardService.instance.request(request);
    await showNotEmpty(response.validationResult.build());
    if (!response.validationResult.isSuccessful) {
        return false;
    }
    
    let userInfoList = response.info.UsersInfo;
    if (!userInfoList || userInfoList!.length == 0) return false;

    roleApprovers.forEach(ra => {
      ra.Approvers.forEach(appr => {
        let userInfo = userInfoList.find(x=>x.RoleID!.$value==appr.ID && (x.RoleKCKID || (x.RolePosition && x.RolePosition!=="")));
        if (userInfo)
        {
          if(userInfo.RoleKCKID) appr.OrganizationKCKID = userInfo.RoleKCKID!.$value
          if(userInfo.RoleKCKExternalID) appr.OrganizationKCKExternalID = userInfo.RoleKCKExternalID!.$value
          if(userInfo.RoleKCKName) appr.OrganizationKCKName = userInfo.RoleKCKName!.$value
          if(userInfo.RoleEntityID) appr.LegalEntityID = userInfo.RoleEntityID!.$value
          if(userInfo.RoleEntityName) appr.LegalEntityName = userInfo.RoleEntityName!.$value
          if(userInfo.RolePosition) appr.Position = userInfo.RolePosition!.$value
        }
      })
    })   

    return true;
  }


  public static async GetApproversByRdDivisionRoles(card: Card, roles: guid[], roleApprovers:RoleApprovers<guid>[])
  {    
    if (!Guid.equals(card.typeId, CdCardTypes.PkRequestForMaterialsTypeID)) return true;
    let objectList = CdExtensionHelper.GetObjectListFromPkObjectListSection(card);
    if (!objectList|| objectList.length == 0) return false; 

    let rolesByDivision = roles.filter(x=>CdRequestForMaterialsSharedHelper.RolesFromRdDivision.some(r=>Guid.equals(r.guid, x)));

    for (let index = 0; index < rolesByDivision.length; index++) {
      const roleID = rolesByDivision[index];
      const request = new CardRequest();
      request.requestType = CdRequestTypes.GetUsersForTable;
      request.info["IdpTeamRoleExtID"] = createTypedField((CdRequestForMaterialsSharedHelper.RolesFromRdDivision.find(x=>Guid.equals(roleID, x.guid))!.number), DotNetType.Int32);
      request.info["ObjectList"] = objectList;

      const response = await CardService.instance.request(request);
      showNotEmpty(response.validationResult.build());
      if (!response.validationResult.isSuccessful) {
          return null;
      }
      let users: [{RoleID, RoleName}] = response.info.Users;
      let approversList:{ID:guid,Name:string}[] = []
      for (let i = 0; i < users.length; i++) {
        let userInfo = users[i];
        if (userInfo.RoleName.$value.length === 0) continue;
        approversList.push({ID:userInfo.RoleID.$value,Name:userInfo.RoleName.$value}); 
      }
      let roleApprover = roleApprovers.find(x => x.RoleID == roleID);
      if (roleApprover != null)
        roleApprover.Approvers.concat(approversList);
      else
        roleApprovers.push({
          RoleID: roleID
          , OrderNumber: createTypedField(null, DotNetType.String)
          , OrderDate: createTypedField(null, DotNetType.DateTime)
          , Approvers: approversList
        });
    }    
    return true;
  }

  /**Получает роли согласования по запросу, заполняет таблицу ими, затем получает и заполняет согласующих по этим ролям
   * !При использовании фильтров на роли не присваивать массиву новую ссылку *(ar=ar.filter)
   */
  public static async FillApprovers(card: Card, ...additionalFilters: ((roles: ApprovementRoles[])=>void)[]) {
    let roles = await this.GetRoles(card, ...additionalFilters);
    await this.FillTableApprovers(card, roles, 'PkApprovementMatching', 'PkApprovementMatchingRoles');
    let roleIds = roles!.map(x => x.RoleID);
    this.GetApprovers(card.clone(), roles).then(
      (result => this.SetApprovers(card, roleIds, result, 'PkApprovementMatching', 'PkApprovementMatchingRoles'))
    );
  }

  /** Заполнение юридического лица в ТЧ #25698 */
  public static ApprovementMatchingRolesChanged(model: ICardModel, matchingSection: string, matchingRolesSection: string) {
    let edrSection = model.card.sections.tryGet(matchingRolesSection);
    let edmSection = model.card.sections.tryGet(matchingSection);
    if (!edrSection || !edmSection) return;
    edrSection.rows.forEach(r => {
      this.AddApproverFieldChanged(r,model,matchingSection);
    });
    edrSection.rows.collectionChanged.add(e => {   
      if (e.added.length > 0) {
        let row = e.added[0];
        this.AddApproverFieldChanged(row,model,matchingSection);
      }      
    });

    let matchingTable = model.controls.get("Matching") as GridViewModel;
    
    matchingTable.rowValidating.add(e => {
          let matchingRowID = e.row.rowId;
          let section = model.card.sections.get(matchingRolesSection);

          if (!section || !matchingRowID) {
            return;
          }

          let cardRow = new CardRow();
          
          section.rows.forEach(r => {
            if (r.tryGet("MatchingRowID") == matchingRowID && r.state != CardRowState.Deleted) {
              cardRow = r;
            }
          });

          this.FillLegalEntityField(cardRow ?? new CardRow(), model.card, matchingRowID, matchingSection);
    });
  }

  public static AddApproverFieldChanged(row: CardRow, model: ICardModel, matchingSection: string)
  {
    row.fieldChanged.add(() => {
          
      if (! row.tryGet("RoleKCKExternalID") 
      || !row.tryGet("RoleKCKID") 
      || !row.tryGet("RoleEntityID") 
      || !row.tryGet("RoleEntityName") 
      || !row.tryGet("RoleKCKName")) return;      
      {                  
        let matchingRowID = row.tryGetField('MatchingRowID');
        if (matchingRowID) {
          this.FillLegalEntityField(row, model.card, matchingRowID.$value, matchingSection);              
        }
      }
    });        
  }

  /** Проверить таблицу согласующих */
  protected static CheckApprovers<T>(context: ICardUIExtensionContext, matchingSectionName: string, matchingRolesSectionName: string, excludeRolesFromCheck : T[] = []) {
    try {
      let card = context.model.card;

      // Проверить что в карточке имеются секции
      let edmSection = card.sections.tryGet(matchingSectionName);
      let edrSection = card.sections.tryGet(matchingRolesSectionName);
      if (!edmSection || !edrSection) {
        return false;
      }
      var rSectionRows = edrSection.rows.filter(x => x.state != CardRowState.Deleted);
      var mSectionRows = edmSection.rows.filter(x => x.state != CardRowState.Deleted);

      if (rSectionRows.length == 0 || mSectionRows.length == 0)
      {
        context.validationResult.add(ValidationResultType.Error, 'Необходимо заполнить согласующих');
            return false;
      }

      if (excludeRolesFromCheck!=null && excludeRolesFromCheck.length>0)
      {
        mSectionRows = mSectionRows.filter(x=>excludeRolesFromCheck.some(r=> x.tryGet("RoleID")==r))
      }

      let rolesToFill: string[] = [];
      mSectionRows
        .filter(x =>
          x.tryGet("RoleID") != CdExecutiveSchemeSharedHelper.GetRoles()[3].IntID
        )
        .forEach(r => {
          let roleID: number | null = r.tryGet("RoleID");
          if (r.tryGet("RoleID") != CdRequestForMaterialsSharedHelper.ApprovementRoles.AdditionalApproversID && rSectionRows.find(x => x.tryGet("MatchingRowID") == r.rowId) == null) {
            if (roleID == 4) {
              // Авторский надзор проверяется, если стоит флаг "Работы выполнены с отклонениями от РД". TES-5659
              let executiveSchemeInfo: CardSection | undefined = card.sections.tryGet('PkExecutiveSchemeInfo');
              if (executiveSchemeInfo) {
                let performedWithDeviation: boolean | null = executiveSchemeInfo.fields.tryGet('PerformedWithDeviation');
                if (performedWithDeviation !== null && performedWithDeviation !== undefined && performedWithDeviation) {
                  rolesToFill.push(r.tryGet("RoleName"))
                }
              }
            }
            else {
              rolesToFill.push(r.tryGet("RoleName"))
            }
          }
        });
     
      if (rolesToFill.length > 0)
      {
        context.validationResult.add(ValidationResultType.Error, 'Необходимо заполнить согласующих для следующих ролей: '+ rolesToFill.join(', '));
      }

      return true;
    } catch (ex) {
      context.validationResult.add(ValidationResultType.Error, 'Ошибка при проверке согласующих.\nТекст ошибки: ' + ex.message + ' ' + ex.stack);
      return false;
    }
  }

  public static CheckApprovementTableOrder(context: ICardUIExtensionContext) {
    let card = context.card;
    let edmSection = card.sections.tryGet('PkApprovementMatching');
    if (edmSection &&
      edmSection.rows.findIndex(x => x.state === CardRowState.Modified ||
        x.state === CardRowState.Inserted) >= 0) {
      this.GetRoles(card).then(result => {
        let step = 0;
        result!.sort((a, b) => a.DefaultOrder - b.DefaultOrder);
        for (let i = 0; i < result!.length; i++) {
          let roleIDIndex = edmSection!.rows.findIndex(x => x.has('RoleID') &&
            x.get('RoleID') === result![i].RoleID);
            if (roleIDIndex>=0){
              edmSection!.rows[roleIDIndex].set('Order', createTypedField(step, DotNetType.Int32));
              step++;
            }          
          }
        }
      );
    }    
  }


  public static async ConfirmApproversChangesDialog<T>(invalidApprovers: InvalidApprovers<T>[]) {
    let errorMessage = "Ошибка при проверке согласующих. Пожалуйста, обратитесь к администратору."
    let result = true;
    let uiContext = UIContext.current;
    let editor = uiContext.cardEditor;
    if (uiContext == null || editor == null ) {
      showError(errorMessage);
      return;
    }

    let meta = MetadataStorage.instance.cardMetadata;
    const dialogsType = meta.getCardTypeByName('PkDialogs');
    if (!dialogsType) {
      showError(errorMessage);
      return;
    }

    const request = new CardNewRequest();
    request.cardTypeId = dialogsType.id;
    const response = await CardService.instance.new(request);
    response.card.id = Guid.newGuid();
    await showNotEmpty(response.validationResult.build());
    if (!response.validationResult.isSuccessful) {
      return;
    }
    const windowCardModel = createCardModel(response.card, response.sectionRows);
    const dialogForm = dialogsType.forms.find(x => x.name === 'ConfirmApproversChanges');
    if (!dialogForm) {
      showError(errorMessage);
      return;
    }

    await showFormDialog(
      dialogForm,
      windowCardModel,
      (_form) => {
        let section = _form.cardModel.card.sections.getOrAdd("PkInvalidApprovers");
        for (let i = 0; i < invalidApprovers.length; i++)
        {
          let newRow = new CardRow();
          newRow.rowId = Guid.newGuid();
          newRow.set("Role", createTypedField(invalidApprovers[i].Role, DotNetType.String));
          newRow.set("Invalid", createTypedField(invalidApprovers[i].Invalid, DotNetType.String));
          newRow.set("Valid", createTypedField(invalidApprovers[i].Valid, DotNetType.String));
          newRow.state = CardRowState.Inserted;
          section.rows.push(newRow);
        }        
      },
      [
        new UIButton('Изменить согласующих', async (btn) => {          
          result = false;
          btn.close();
        }),
        new UIButton('Оставить без изменений', (btn) => {
          result = true;
          btn.close();
        }),
      ]
    );
    return result;
  }
  

  protected static async GetInvalidApprovers<T>(card: Card, roleApprovers: RoleApprovers<T>[]|undefined|null, matchingSectionName: string, matchingRolesSectionName: string )
  {
    let invalidApprovers: InvalidApprovers<T>[] = [];
    let errorMessage = "";
    let edMatchingSection: CardSection | undefined = card.sections.tryGet(matchingSectionName);
    let edRolesSection: CardSection | undefined = card.sections.tryGet(matchingRolesSectionName);
    if (!edMatchingSection) return; 
    if (!edRolesSection || edRolesSection.rows.length==0)
    {
      errorMessage = "Согласующие не заполнены";
      return errorMessage;
    }
    if (roleApprovers==undefined)
      return;

    edMatchingSection.rows.forEach(row=>{
      let roleID = row.tryGetField("RoleID")!.$value;
      if (!roleID) return;
      let roleApprover = roleApprovers!.find(x=>x.RoleID==roleID);
      if (!roleApprover) return;
      let matchingRoles = edRolesSection!.rows.filter(x=>x.tryGetField("MatchingRowID")!.$value==row.rowId).map(x=> ({RoleID:x.tryGetField("RoleID")!.$value,RoleName: x.tryGetField("RoleName")!.$value }) );
      if (roleApprover.Approvers.findIndex(x=>matchingRoles.findIndex(mr=>mr.RoleID===x.ID)==-1)!=-1)
      {
        invalidApprovers.push({
          RoleID: roleID
          , Role: row.tryGetField("RoleName")!.$value
          , Valid:roleApprover.Approvers.map(x=>x.Name).join(";")
          , Invalid: matchingRoles.map(x=>x.RoleName as string).join(";")
        });
      }
    }); 
   
    return invalidApprovers;
  }

   /** Проверить добавление нового согласующего в ТЧ */
   public static CheckAddNewMatchingRoles(context: ICardUIExtensionContext, matchingSectionName: string, matchingRolesSectionName: string) {
    try {
      let card = context.model.card;
      let edmSection = card.sections.tryGet(matchingSectionName);
      let edrSection = card.sections.tryGet(matchingRolesSectionName);
      if (edmSection && edrSection &&
          (edmSection.rows.findIndex(x =>
            x.state === CardRowState.Modified) >= 0 ||
          edrSection.rows.findIndex(x =>
            x.state === CardRowState.Inserted ||
            x.state === CardRowState.Modified) >= 0)) {
          context.validationResult.add(ValidationResultType.Error, 'Сохраните карточку перед тем как продолжить');
          return false;
        }
      return true;
    } catch (ex) {
      context.validationResult.add(ValidationResultType.Error, 'Ошибка при проверке добавления новых согласующих.\nТекст ошибки: ' + ex.message + ' ' + ex.stack);
      return false;
    }
  }

  protected static async SetApprovers<T>(card: Card, roles: T[],roleApprovers: RoleApprovers<T>[]|null|undefined, matchingSectionName: string, matchingRolesSectionName: string)
  {    
    let edRolesSection: CardSection | undefined = card.sections.tryGet(matchingRolesSectionName);
    let edMatchingSection: CardSection | undefined = card.sections.tryGet(matchingSectionName);

    // удаляем согласующих, если строка роли была удалена
    if (!edRolesSection || !edMatchingSection) return;    
    for (let j = edRolesSection.rows.length - 1; j >= 0; j--) {
      let row = edRolesSection.rows[j];     
      if (!edMatchingSection.rows.some(x =>
        x.state != CardRowState.Deleted &&
        row.has('MatchingRowID') &&
        row.tryGet('MatchingRowID') === x.rowId &&
        x.has('RoleID')))      
      {
        if (row.state !== CardRowState.Inserted) {
          row.state = CardRowState.Deleted;
        }
        else
        {
          edRolesSection.rows.remove(row);
        }
      }        
    }

    roles.forEach(role => {
      if (!edRolesSection || !edMatchingSection) return;
      for (let j = edRolesSection.rows.length - 1; j >= 0; j--) {
        let row = edRolesSection.rows[j];     
        let edmRow = edMatchingSection.rows.find(x =>
          x.state != CardRowState.Deleted &&
          row.has('MatchingRowID') &&
          row.tryGet('MatchingRowID') === x.rowId &&
          x.has('RoleID') &&
          x.tryGet('RoleID') === role);
        if (!edmRow) {
          continue;
        }
        else
        {
          if (row.state !== CardRowState.Inserted) {
            row.state = CardRowState.Deleted;
          }
          else
          {
            edRolesSection.rows.remove(row);
          }
        }        
      }

      let row = edMatchingSection.rows.find(x=>x.tryGetField('RoleID')!.$value === role && x.state!= CardRowState.Deleted);
      if (!row) return;
      
      let currentRoleApprover = roleApprovers!.find(x=>x.RoleID===role)
      if (currentRoleApprover==null) return;
      row.set('OrderNumber', currentRoleApprover.OrderNumber);
      row.set('OrderDate', currentRoleApprover.OrderDate);
      currentRoleApprover.Approvers.forEach(approver => {

        let newRow = new CardRow();      
       
        newRow.rowId = Guid.newGuid();
        newRow.set("MatchingRowID", createTypedField(row!.rowId, DotNetType.Guid));
        newRow.set("RoleID", createTypedField(approver.ID, DotNetType.Guid));
        newRow.set("RoleName", createTypedField(approver.Name, DotNetType.String));

        if (approver.OrganizationKCKID) {
          newRow.set("RoleKCKID", createTypedField(approver.OrganizationKCKID, DotNetType.Guid)); 
          row!.set("LegalEntityID", createTypedField(approver.OrganizationKCKID, DotNetType.Guid));  
        }
        if (approver.OrganizationKCKName) {
          newRow.set("RoleKCKName", createTypedField(approver.OrganizationKCKName, DotNetType.String));  
          row!.set("LegalEntityName", createTypedField(approver.OrganizationKCKName, DotNetType.String));  
        }
        if (approver.OrganizationKCKExternalID) {
          newRow.set("RoleKCKExternalID", createTypedField(approver.OrganizationKCKExternalID, DotNetType.Int64));  
          row!.set("LegalEntityExternalID", createTypedField(approver.OrganizationKCKExternalID, DotNetType.Int64));  
        }
        if (approver.LegalEntityID) newRow.set("RoleEntityID", createTypedField(approver.LegalEntityID, DotNetType.Guid));
        if (approver.LegalEntityName) newRow.set("RoleEntityName", createTypedField(approver.LegalEntityName, DotNetType.String));
        if (approver.Position) newRow.set("RolePosition", createTypedField(approver.Position, DotNetType.String));
        newRow.state = CardRowState.Inserted;
        card.sections.get(matchingRolesSectionName)!.rows.push(newRow);
      });        

    });    
  }

  public static MatchingVisabilityLogic (context: ICardUIExtensionContext){
    let card : Card = context.model.card;
    if (!card.sections.tryGet("PkObjectList"))
      return;
    let matchingControl : IControlViewModel | undefined = context.model.controls.get("Matching");
    if (!matchingControl)
      return;
    let matchingTable = matchingControl as GridViewModel;
    matchingTable.rowInitializing.add(async e =>{
      if (!this.CheckObjectsAreFilled(card)){
        if (card.typeId == CdCardTypes.PkExecutiveDocumentationTypeID)
          showMessage("Для заполнения таблицы согласования выберите объект");
        if (card.typeId == CdCardTypes.PkExecutiveSchemeTypeID)
          showMessage("Для заполнения таблицы подписания выберите объект");
        e.cancel = true;
      }    
      else if(e.row.has("RoleID") && e.row.get("RoleID") == ApproversRoleID.Customer)
      {       
        let objectList = card.sections.tryGet("PkObjectList");
        if (context.card.hasChanges() && objectList && objectList.rows.some(r => r.state != CardRowState.None && r.has("ObjectID")))
        {
          showMessage("Перед заполнением согласующих данной роли, сохраните карточку");
          e.cancel = true;
        }
        
        let isExternalBuilder = CdUIHelper.GetUIControl<CheckBoxViewModel>(context, "isExternalBuilder");    
        let approversControl = e.rowModel?.controls.get("Approvers");
        if (!approversControl) return;
        let approversTable = approversControl as GridViewModel;

        approversTable!.rowInvoked.add(async ee => {
          if (!isExternalBuilder || isExternalBuilder.isChecked === false) return;
          let currentRow = ee.row
          if (ee.action === GridRowAction.Inserted)
          { 
            
            let pkExecutiveDocumentationRolesSection = card.sections.getOrAdd("PkExecutiveDocumentationRoles");
            ee.cancel = true;
            let newRow = new CardRow();
            newRow.rowId = Guid.newGuid();   
            newRow.set("RoleID", createTypedField("11111111-1111-1111-1111-111111111111", DotNetType.Guid));
            if (await CdGeneralDocumentationClientHelper.addExternalBuilderApproverDialog(newRow)) 
            {
              newRow.set("MatchingRowID", e.row.rowId, DotNetType.Guid);          
              newRow.state = CardRowState.Inserted;
              pkExecutiveDocumentationRolesSection!.rows.push(newRow);
            }
          }
          if (ee.action === GridRowAction.Opening){                 
            
            ee.cancel = true;     
            if (await CdGeneralDocumentationClientHelper.addExternalBuilderApproverDialog(currentRow))            
              currentRow.state = CardRowState.Modified;
          }

        });     
      }
    });
  }

  public static async addExternalBuilderApproverDialog(approverRow: CardRow): Promise<boolean> {
   
    const dialogsType = MetadataStorage.instance.cardMetadata.getCardTypeByName('PkDialogs');
    if (!dialogsType) {
      return false;
    }
    const dialogForm = dialogsType.forms.find(x => x.name === 'AddExternalBuilderApproverDialog');
    if (!dialogForm) {
      return false;
    }
    const request = new CardNewRequest();
    request.cardTypeId = dialogsType.id;
    const response = await CardService.instance.new(request);
    response.card.id = Guid.newGuid();
    await showNotEmpty(response.validationResult.build());
    if (!response.validationResult.isSuccessful) {
      return false;
    }
    let result = false;
    const windowCardModel = createCardModel(response.card, response.sectionRows);  
    let sectionRow = windowCardModel.card.sections.getOrAdd("PkExternalBuilderApproverVirtual").fields;            
    if (approverRow)
    {
        if (approverRow.has("RoleName")) sectionRow.set("RoleName", createTypedField(approverRow.get("RoleName"), DotNetType.String));
        if (approverRow.has("RolePosition")) sectionRow.set("RolePosition", createTypedField(approverRow.get("RolePosition"), DotNetType.String));
        if (approverRow.has("RoleKCKID")) sectionRow.set("PartnerID", createTypedField(approverRow.get("RoleKCKID"), DotNetType.Guid)); 
        if (approverRow.has("RoleKCKExternalID")) sectionRow.set("PartnerExternalID", createTypedField(approverRow.get("RoleKCKExternalID"), DotNetType.Int64));
        if (approverRow.has("RoleKCKName")) sectionRow.set("PartnerName", createTypedField(approverRow.get("RoleKCKName"), DotNetType.String));
    }
    await showFormDialog(
      dialogForm,
      windowCardModel,  
      null,
      [
        new UIButton('Cохранить', async (btn) => {
          let msg = "";
          if (sectionRow.get("RoleName") == null) msg += "Поле \"Согласующий\" обязательно для заполнения!\r\n";
          if (sectionRow.get("PartnerID") == null) msg += "Поле \"Организация\" обязательно для заполнения!\r\n";

          if (msg !== "") 
          {
              showError("Для заполнения таблицы подписания выберите объект");(msg);
              return;
          }
          approverRow.set("RoleName", createTypedField(sectionRow.get("RoleName"), DotNetType.String));
          approverRow.set("RolePosition", createTypedField(sectionRow.get("RolePosition"), DotNetType.String));
          approverRow.set("RoleKCKID", createTypedField(sectionRow.get("PartnerID"), DotNetType.Guid));
          approverRow.set("RoleKCKExternalID", createTypedField(sectionRow.get("PartnerExternalID"), DotNetType.Int64));
          approverRow.set("RoleKCKName", createTypedField(sectionRow.get("PartnerName"), DotNetType.String));

          result = true;      
          btn.close();
        })
      ]
    );
    return result;
  }

  /** Проверка после завершении задания */
  public static async CheckFieldsAfterTaskComplete(context: ICardUIExtensionContext, tasks: ArrayStorage<CardTask>,checkTaskTypes: guid[], checkTaskOptions: guid[]
    , categoryList: (guid|null)[], excludeRolesFromCheck?: guid[], taskTypesSigning?: guid[]) {
    let deletedTaskIndex = tasks.findIndex(x => x.state === CardRowState.Deleted);
    if (deletedTaskIndex >= 0) {
      let checkAddedFiles: boolean = await this.CheckAddedFiles(context, 1,checkTaskTypes,checkTaskOptions,categoryList);
      let checkAddNewMatchingRoles: boolean = this.CheckAddNewMatchingRoles(context,'PkApprovementMatching','PkApprovementMatchingRoles');
     
      if (!checkAddedFiles ||
          !checkAddNewMatchingRoles          
          ) {
        context.cancel = true;
        return;
      }
    }

    deletedTaskIndex = tasks.findIndex(x =>
      x.state === CardRowState.Deleted &&
      (checkTaskTypes.find(xt=>xt===x.typeId)!=null) &&
      (checkTaskOptions.find(xt=>xt===x.optionId)!=null));
    
    if (deletedTaskIndex >= 0) {


      let checkContentFile: boolean = await CdUIHelper.CheckContentFileAsync(context.model.card);
      let checkApprovers: boolean = this.CheckApprovers<guid>(context,'PkApprovementMatching','PkApprovementMatchingRoles', excludeRolesFromCheck);

      if (!checkContentFile) {
        context.cancel = true;
        return;
      }

      //убираем проверку актуальности согласующих
      // let roles = (await this.GetRoles(context.model.card))!.map(x=>x.RoleID);     

      // var approvers = await this.GetApprovers(context.model.card,roles);
      // if (approvers!.length>0)
      // {
      //   let invalidApprovers = await this.GetInvalidApprovers(context.model.card,approvers,'PkApprovementMatching','PkApprovementMatchingRoles');
      //   if (invalidApprovers!.length>0)
      //   { 
      //     let result = await this.ConfirmApproversChangesDialog(invalidApprovers as InvalidApprovers<guid>[])
      //     if (result==undefined)
      //     {
      //       context.cancel = true;
      //       return;
      //     }
      //     else if (result as boolean == false) {
      //       context.cancel = true;
      //       this.SetApprovers(context.uiContext!.cardEditor!.cardModel!.card,roles.filter(x=>(invalidApprovers as InvalidApprovers<guid>[]).findIndex(ia=>ia.RoleID==x)!=-1)
      //       ,approvers
      //       ,'PkApprovementMatching','PkApprovementMatchingRoles')
                      
      //       return;
      //     }
          
      //   }
      // }

      if (!checkApprovers) {
        context.cancel = true;
        return;
      }   
    } 
    if (taskTypesSigning!=null && taskTypesSigning.length>0)
        await this.SignFilesAsync(context, tasks, taskTypesSigning);
  }

  public static Base64ToBlob(base64Data, contentType) {
    contentType = contentType || '';
    let sliceSize = 1024;
    let byteCharacters = atob(base64Data);
    let bytesLength = byteCharacters.length;
    let slicesCount = Math.ceil(bytesLength / sliceSize);
    let byteArrays = new Array(slicesCount);
    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      let begin = sliceIndex * sliceSize;
      let end = Math.min(begin + sliceSize, bytesLength);
      let bytes = new Array(end - begin);
        for (let offset = begin, i = 0 ; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  }

  /** Проверка файлов
  * from: 0 - ui, 1 - задание */
 public static async CheckAddedFiles(context: ICardUIExtensionContext, from: number,checkTaskTypes: guid[], checkTaskOptions: guid[], categoryList: (guid|null)[]) {
  let card: Card = context.model.card;
  let result: boolean = true;

  switch (from) {
    // Проверяемые расширения файлов
    case 0:
      const availibleFileExtensions: string[] = [ 'DOCX', 'DOC', 'XLSX', 'XLS', 'PDF', 'SGN' ];
      for (let i = 0; i < card.files.length; i++) {
        let file = card.files[i];
        if (file.state === CardFileState.Deleted ||
            file.state === CardFileState.None ||
            file.name.toLowerCase() === 'история согласования.html') continue;
        let correctFile: boolean = false;
        for (let j = 0; j < availibleFileExtensions.length; j++) {
          let ext = availibleFileExtensions[j];
          if (file.name.toUpperCase().indexOf('.' + ext) !== -1) {
            correctFile = true;
            break;
          }
        }
        if (!correctFile) {
          showError('Приложенные файлы должены быть в формате: ' + availibleFileExtensions.join(', '));
          context.cancel = true;
          return true;
        }
      }
      break;
    // Проверка наличия файлов в категориях
    case 1:
      // Проверка, что все файлы сохранены
      if (context.card.tasks.findIndex(x =>
            x.state === CardRowState.Deleted &&
            checkTaskTypes.find(xt=>xt===x.typeId)!=null) >= 0 &&
          card.files.findIndex(x =>
            x.state === CardFileState.Inserted ||
            x.state === CardFileState.Modified ||
            x.state === CardFileState.ModifiedAndReplaced ||
            x.state === CardFileState.Replaced) >= 0) {
        context.validationResult.add(ValidationResultType.Error, 'Пожалуйста, сохраните карточку перед тем как продолжить.');
        return false;
      }
      // Проверка файлов в категориях
      let pdciSection: CardSection | undefined = card.sections.tryGet('PkDocumentCommonInfo');
      if ( !pdciSection) break;
   
      let stateID: number | null | undefined = pdciSection.fields.tryGet('StateID');
      if (!stateID) break;
      for (let i = 0; i < context.card.tasks.length; i++) {
        let task = context.card.tasks[i];
        if (task.state !== CardRowState.Deleted ||
            !task.optionId) continue;
      
        if (checkTaskTypes.findIndex(x=>task.typeId.toLowerCase()===x) >= 0 &&
           checkTaskOptions.findIndex(x=>task.optionId!.toLowerCase()===x) >= 0) {         
          
          for (let j = 0; j < categoryList.length; j++) {
            let categoryId = categoryList[j];             

            let fileIndex = card.files.findIndex(x =>
              x.categoryId !== null &&
              x.categoryId.toLowerCase() === categoryId!.toLowerCase());
            if (fileIndex === -1) {
              let category = ChFileCategories.FileCategories.find(x => x.id === categoryId);
              if (category)
                context.validationResult.add(ValidationResultType.Error, 'Загрузите файл в категорию "' + category.caption + '"');
                result = false;
                break;
            }
          }
        }
      }
      break;
  }

  return result;
}  

  /** Проверить что подписанный файл изменялся и пользователь согласен с изменениями */
  public static async CheckEditSignedFile(card: Card) {
    let hasSign: boolean = false;
    for (let i = 0; i < card.files.length; i++) {
      let file: CardFile = card.files[i];
      if ((file.state === CardFileState.Deleted ||
          file.state === CardFileState.ModifiedAndReplaced ||
          file.state === CardFileState.Replaced) &&
        !hasSign) {
        const request = new CardRequest();
        request.requestType = CdRequestTypes.SignInfo;
        request.info["OnlySignAvailability"] = createTypedField(true, DotNetType.Boolean);
        request.info["FileID"] = createTypedField(file.rowId, DotNetType.Guid);
        request.info["TypeID"] = createTypedField(card.typeId, DotNetType.Guid);
        const response = await CardService.instance.request(request);

        if (response.validationResult.build().isSuccessful) {
          let result: boolean | null = response.info!.Result.$value;
          if (result) {
            hasSign = true;
            break;
          }
        }
      }
    }

    if (hasSign) {
      let dialogResult: boolean = confirm('Внимание! При редактировании документа электронные подписи станут недействительными. Документ потребуется подписывать повторно. Подтверждаете необходимость отредактировать файл?');
      if (!dialogResult) {
        return false;
      }
    }

    return true;
  }


  /** Заполнение юридического лица в ТЧ #25698 */
  public static FillLegalEntityField(row: CardRow, card: Card, matchingRowID: string, matchingSectionName:string) {
    let section = card.sections.tryGet(matchingSectionName);
    if (!section) return;
    let mRow = section.rows.find(x => x.rowId.toLowerCase() === matchingRowID.toLowerCase());
    if (!mRow) return;
    if (!row.has('RoleKCKExternalID') || !row.has('RoleKCKID') || !row.has('RoleKCKName') ||
      row.tryGet('RoleKCKExternalID') === -1 || row.tryGet('RoleKCKID') === '00000000-0000-0000-0000-000000000000' || row.tryGet('RoleKCKName') === '' || row.tryGet('RoleKCKExternalID') === null) {
        mRow.set('LegalEntityExternalID', null);
        mRow.set('LegalEntityID', null);
        mRow.set('LegalEntityName', null);
    }
    else {
      mRow.set('LegalEntityExternalID', createTypedField(row.tryGet('RoleKCKExternalID'), DotNetType.Int64));
      mRow.set('LegalEntityID', createTypedField(row.tryGet('RoleKCKID'), DotNetType.Guid));
      mRow.set('LegalEntityName', createTypedField(row.tryGet('RoleKCKName'), DotNetType.String));
    }
  }

  /**Скрываем таблицу подписантов, если объект не заполнен */
  public static CheckObjectsAreFilled(card: Card) : boolean{
    if (card.sections.tryGet("PkObjectList")!.rows.length > 0)
      return true;
    else
      return false;
  }

  /**Ищем последнюю запись в строковой секции */
  public static GetLast(card: Card) : boolean{
    if (card.sections.tryGet("PkObjectList")!.rows.length > 0)
      return true;
    else
      return false;
  }
}


export interface RoleApprovers<T>{
  RoleID: T;
  OrderNumber: TypedField<DotNetType.String, any>;
  OrderDate: TypedField<DotNetType.DateTime, any>;
  Approvers: {ID:guid,Name:string,OrganizationKCKID?:guid,OrganizationKCKName?:string,OrganizationKCKExternalID?:number,LegalEntityID?:guid,LegalEntityName?:string,Position?:string}[]
} 

export interface InvalidApprovers<T>{
  RoleID: T;
  Role: string;
  Invalid: string;
  Valid: string;
} 

export interface ApprovementRoles{
  RoleID: guid;
  RoleName: string;
  SpecialRoleID: guid;
  SpecialRoleName: string;
  DefaultOrder: number;
  ApprovementRolesCriteria: ApprovementRolesCriteria[] | null;
  ApprovementRolesActiveCriteria: ApprovementRolesCriteria[] | null;
} 

export interface ApprovementRolesCriteria{
  RowID: guid;
  SectionName: string;  
  FdCriteriaOperatorID: number | null;
  FieldName: string;
  Value: string;
} 

export class Objects {
  public ObjectsId: Array<DotNetType.Guid>;
}
export class FillMatching{
  public CopiedID: DotNetType.Guid;
  public ID: DotNetType.Guid;
  public IsExists: boolean
}



enum FdCriteriaOperators
{
    Equals = 0,
    NonEquals = 1,
    GreatThan = 2,
    LessThan = 3,
    GreatOrEquals = 4,
    LessOrEquals = 5,
    IsNull = 6,
    IsNotNull = 7,
    Between = 8,
    Contains = 9,
    StartsWith = 10,
    EndsWith = 11,
    IsTrue = 12,
    IsFalse = 13,
    InRole = 14,
    ContainsAll = 15,
    ContainsAny = 16,
    NotContainsAny = 17,
    NotInRole = 18,
    ContainsInTable = 19,
    ContainsInRow = 20
}
